import React, { useCallback, useEffect, useState } from 'react'
import { Observer } from 'mobx-react'
import _isEmpty from 'lodash/isEmpty'
import _isNil from 'lodash/isNil'

import API, { DATA_API } from 'helpers/api'
import accountStore from 'config/store/AccountStore'

import AsyncFilterField, { AsyncFilterFieldProp } from './AsyncFilterField'
import { useCallTableFilterStore } from '../../store/CallTableFilterStore'
import { useStores } from 'config/store'
import { repository as insuranceRepo } from 'models/insurance/Insurance'

type SfFieldType = {
  Insurance_Provider__c: string | null
  Insurance_Provider__r: null | { Name: string }
}
const getSource = async (params: { accountIds: string[] }) => {
  const result = (await API.get({
    api: DATA_API,
    url: '/insurances/inquiries',
    params,
  })) as []

  const mapResponse = (a: SfFieldType): AsyncFilterFieldProp['source'][0] => ({
    label: a?.Insurance_Provider__r?.Name ?? 'N/A',
    value: a?.Insurance_Provider__c ?? '',
  })

  const insurancesMap = new Map<
    AsyncFilterFieldProp['source'][0]['value'],
    AsyncFilterFieldProp['source'][0]
  >()
  const insurances = (result ?? [])
    .filter((a: SfFieldType) => !_isNil(a?.Insurance_Provider__c))
    .map(mapResponse)
  insurances.forEach((a) => insurancesMap.set(a.value, a))

  return Array.from(insurancesMap.values())
}

const KEY = 'insurance'
const LABEL = 'Insurance'

export default function InsuranceFilterField() {
  const { callsStore } = useStores()
  const store = useCallTableFilterStore()
  const filter = store.filterRegistry.get(KEY)
  const initialValue = callsStore.filters[KEY] ?? []

  const [loading, setLoading] = useState(false)

  const initialSource = initialValue.map((id: string) => {
    const insurance = insuranceRepo.get(id)
    return { label: insurance.name, value: id }
  })
  const [source, setSource] =
    useState<AsyncFilterFieldProp['source']>(initialSource)

  useEffect(() => {
    store.registerFilter(KEY, {
      label: LABEL,
      value: initialValue,
      active: Boolean(initialValue && initialValue.length),
      type: 'LIMITED',
    })
  }, [])

  useEffect(() => {
    const accountIds = (accountStore.selectedAccounts || []).slice()
    setLoading(true)
    getSource({ accountIds }).then((picklist) => {
      setLoading(false)
      setSource(picklist)
    })
  }, [accountStore.selectedAccounts])

  const onChange = useCallback((value: AsyncFilterFieldProp['value']) => {
    store.setFilterValue(KEY, _isEmpty(value) ? undefined : value)
    store.runFilter()
  }, [])

  return (
    <Observer
      render={() => {
        const isShown = filter?.active ?? false
        const value = filter?.value ?? []
        return (
          <AsyncFilterField
            multiple
            loading={loading}
            label={LABEL}
            value={value}
            source={source}
            shown={isShown}
            onChange={onChange}
          />
        )
      }}
    />
  )
}
